
module.exports = {
   
    heading: "My Profile",
   
   
   

}